// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OAXmwucNOGgZwnQecLcv{display:inline-flex;align-items:center;gap:calc(var(--padding)/2)}.OAXmwucNOGgZwnQecLcv>label{margin-bottom:0}`, "",{"version":3,"sources":["webpack://./src/form_components/switch-wrapper/switch-wrapper.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,kBAAA,CACA,0BAAA,CAEA,4BACE,eAAA","sourcesContent":[".container {\n  display: inline-flex;\n  align-items: center;\n  gap: calc(var(--padding) / 2);\n\n  & > label {\n    margin-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OAXmwucNOGgZwnQecLcv`
};
export default ___CSS_LOADER_EXPORT___;
